let baseUrl = 'http://www.lxcia.com'

export default {
    baseUrl
}